import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateJob, Job, JobListResponse, JobQueryParams, UpdateJob } from '@frontend/report/types';

export class JobClient extends APIClient {
    public static readonly endpoint = '/report-api/v1';

    public static async fetchJobs(queryParams?: ApiQueryParams<JobQueryParams>): Promise<JobListResponse> {
        return await this.apiPaginated<JobListResponse, JobQueryParams>(`${this.endpoint}/jobs`, queryParams);
    }

    public static async resolveJobs(ids: string[], field: keyof Job = 'id'): Promise<JobListResponse> {
        const response = await this.post(`${this.endpoint}/jobs-resolve`, { field, ids: ids });
        return await this.handleResponse<JobListResponse>(response);
    }

    public static async deleteJobs(jobIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/jobs-delete`, { ids: jobIds });
        return await this.handleVoidResponse(response);
    }

    public static async postJob(accountId: string, reportId: string, job: CreateJob): Promise<Job> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/jobs`, job);
        return await this.handleResponse<Job>(response);
    }

    public static async exportJob(accountId: string, reportId: string, job: CreateJob): Promise<Blob> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/export-jobs`, job);
        return await this.handleBlobResponse(response);
    }

    public static async fetchJob(accountId: string, reportId: string, jobId: string): Promise<Job> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/jobs/${jobId}`);
        return await this.handleResponse<Job>(response);
    }

    public static async patchJob(accountId: string, reportId: string, jobId: string, job: UpdateJob): Promise<Job> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/jobs/${jobId}`, job);
        return await this.handleResponse<Job>(response);
    }

    public static async deleteJob(accountId: string, reportId: string, jobId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/jobs/${jobId}`);
        return await this.handleVoidResponse(response);
    }
}
